import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import getIncluded from '../../japi/getIncluded'
import isResourceCollectionDocument from '../../japi/guards/isResourceCollectionDocument'
import { JapiDocument } from '../../japi/types/Document'
import { DepartmentGroupResource } from '../DepartmentGroup/DepartmentGroup'
import { FetchCollectionResult, FetchResultType } from '../FetchResult'
import { Department, DepartmentResource } from './Department'
import { transformToDepartment } from './DepartmentTransformers'

export const getDepartmentsIndexCall = async (): Promise<FetchCollectionResult<Department[], string>> => {
    try {
        const url = generateApiUrl({
            endpoint: '/departments',
            queryParams: {
                include: 'group',
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! isResourceCollectionDocument<DepartmentResource>(doc)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const departments = doc.data.map(departmentResource => {
            const departmentGroupResource = getIncluded(doc, departmentResource, 'group') as DepartmentGroupResource

            return transformToDepartment(departmentResource, departmentGroupResource)
        })

        return {
            amountOfPages: 1,
            status: response.status,
            type: FetchResultType.Success,
            data: departments,
        }
    } catch (error) {
        console.error('[getDepartmentsIndexCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
